module.exports = __webpack_public_path__ + "static/media/tattoo-unselected.8c9b6c90.png";